const REFRESH_MS = 250;

/** Painel de depuração por cima da tela do jogo. */
export class DebugHud {
  private timer: number | undefined;

  constructor(
    private readonly element: HTMLElement,
    private readonly render: () => string[],
  ) {}

  get visible(): boolean {
    return !this.element.hidden;
  }

  toggle(force?: boolean): void {
    const show = force ?? this.element.hidden;
    this.element.hidden = !show;
    window.clearInterval(this.timer);
    if (show) {
      this.update();
      this.timer = window.setInterval(() => this.update(), REFRESH_MS);
    }
  }

  private update(): void {
    this.element.textContent = this.render().join('\n');
  }
}
